module.exports = __webpack_public_path__ + "img/tencent-group-qrcode.b26b11ad.png";